module.exports = __webpack_public_path__ + "img/garbage_icon.ca46b2bb.svg";